import { captureMessage } from '@sentry/nextjs';

import { SITE_BASE_URL } from '@/constants';
import { abbreviateNumber } from '@/lib/abbreviateNumber';
import { fetchJSON } from '@/lib/http';
import { splitNumber } from '@/lib/splitNumber';
import { ACTIVE_NEWSLETTERS } from '@/newsletters';

/** This returns the subscriber count for the Daily Digest only */
export async function getSubscriberCount() {
  const URL = `${SITE_BASE_URL}/wp-json/api/public/stats`;
  let rawCount = ACTIVE_NEWSLETTERS.dailyDigest.fallbackSubscriberCount;

  const data = await fetchJSON(URL, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    next: { revalidate: 3600 },
  });

  if (data?.success) {
    rawCount = data?.data.total_subscribers;
  } else {
    console.error(
      'Unable to reach stats API, falling back to default value. Response: ',
      data,
    );

    captureMessage(
      `Unable to reach stats API, falling back to default value. Response: ${JSON.stringify(
        data,
      )}`,
      'error',
    );
  }

  return {
    raw: rawCount,
    abbr: abbreviateNumber(rawCount),
    split: splitNumber(rawCount),
    commaSep: splitNumber(rawCount)?.join(',') || '',
  };
}
